import script from "./Assessment.vue?vue&type=script&setup=true&lang=js"
export * from "./Assessment.vue?vue&type=script&setup=true&lang=js"

import "./Assessment.vue?vue&type=style&index=0&id=a34143ce&scoped=true&lang=css"

import exportComponent from "/builds/skilltech-ph/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a34143ce"]])

export default __exports__